//hooks
import { UseLanguages } from './Languages.hooks';

//components
import LanguagesTab from '@/components/elements/languages/tabs/languagesTab/LanguagesTab';
import NotificationBar, { INotificationBar } from '../../../elements/languages/NotificationBar';
import ModalWrapper from '@/components/modals/ModalWrapper';
import QuickTranslate from '@/components/modals/QuickTranslate';
import DoNotTranslateTab from '@/components/elements/languages/tabs/doNotTranslateTab/DoNotTranslateTab';
import { BasicButton, ClassicNavigationBar, IconLibrary, ThriveIcon } from 'thrive-components';

//interfaces
import {LanguageTabs} from "../../../../interfaces/languages";

//styles
import '../../../../css/orgSettings/languages/languages.scss';



const Languages = () => {
    const {
        quickTranslateModal,
        setQuickTranslateModal,
        dctEnabled,
        setDctEnabled,
        quickTranslateDisabled,
        setQuickTranslateDisabled,
        toggleNotification,
        notification,
        selectedTab,
        setSelectedTab
    } = UseLanguages();

    return (
        <div className="languages-react">
            <h1 className="h1">Languages</h1>

            {dctEnabled && 
                <BasicButton 
                    className={`quick-translate ${quickTranslateDisabled ? 'disabled' : ''}`} 
                    onButtonClick={() => setQuickTranslateModal(true)}
                    isDisabled={quickTranslateDisabled}
                    content={<><ThriveIcon iconName={IconLibrary.CLOCK} color="var(--thriveWhite)" sizeInPx='18'/> Quick Translate</>} 
                    ariaLabel={'Open the translation modal'} 
                />
            }

            <ClassicNavigationBar
                navigationItems={[
                    {
                        id: 1,
                        title: "Languages",
                        onClick: () => setSelectedTab(LanguageTabs.language),
                        isSelected: selectedTab === LanguageTabs.language,
                    },
                    ...(dctEnabled
                        ? [
                            {
                                id: 2,
                                title: "Do Not Translate",
                                onClick: () =>
                                    setSelectedTab(LanguageTabs.doNotTranslate),
                                isSelected:
                                    selectedTab === LanguageTabs.doNotTranslate,
                            },
                        ]
                        : []),
                ]}
            />

            <LanguagesTab
                show={selectedTab === LanguageTabs.language}
                setDctEnabled={setDctEnabled}
                dctEnabled={dctEnabled}
                setQuickTranslateDisabled={setQuickTranslateDisabled}
                toggleNotification={toggleNotification}
            />

            <DoNotTranslateTab
                show={selectedTab === LanguageTabs.doNotTranslate && dctEnabled}
            />

            <ModalWrapper className="quickTranslateContainer" isOpen={quickTranslateModal} onRequestClose={() => setQuickTranslateModal(false)}>
                <QuickTranslate close={(notif:INotificationBar) => { setQuickTranslateModal(false); toggleNotification(notif) }} />
            </ModalWrapper> 

            <NotificationBar 
                show={notification.show} 
                notificationStatus={notification.notificationStatus} 
                msg={notification.msg} 
                notificationType={notification.notificationType}
            />
        </div>
    );
};

export default Languages;